import React, {useContext, useMemo} from 'react';
import {Controller} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {FormFieldConfigSize} from '@src/@types/components/Form';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import CustomSelect from '@src/components/Fields/CustomSelect';
import classnames from '@src/helpers/classnames';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import {IClientModel} from '@src/@interfaces/models/Client/IClientModel';
import trans from '@src/helpers/trans';
import {LocaleContext} from '@src/contexts/LocaleContext';

export function TypeField({rowIndex: index}: IListColumnProps) {
    const {
        control,
        fieldName,
        modelOptions = {},
        forceDisabled,
        forceReadonly
    } = useContext<IFormFieldItemPropsContext<IClientModel> | null>(FormFieldItemPropsContext) ?? {};
    const {locale} = useContext(LocaleContext);
    const [design] = useContext(FormFieldDesignContext);

    const options = useMemo(() => {
        return (modelOptions.contactTypes ?? []).map(item => {
            item.label = trans(item.label, locale);

            return item;
        });
    }, [locale, modelOptions.contactTypes]);

    return <>
        <Controller
                control={control}
                name={`${fieldName}.${index}.type`}
                render={({field: {name, value, onChange, onBlur}, fieldState: {error}}) => {
                    return <CustomSelect
                            label="ClientsShow.fields.contacts.type"
                            className={classnames({
                                'is-invalid': Boolean(error)
                            })}
                            name={name}
                            size={FormFieldConfigSize.SM}
                            options={options}
                            readOnly={design.fieldsAreReadOnly || forceReadonly}
                            disabled={design.fieldsAreDisabled || forceDisabled}
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            menuPortalTarget={document.body}
                    />;
                }}
        />

        <FormErrorMessage fieldName={`${fieldName}.${index}.type`}/>
    </>;
}
